// TODO: here should be the implementation of a basic ConfigurationService

import { Emitter } from "../../../base/common/events";
import { IConfigurationChangeEvent, IConfigurationService } from "./configuration";


export class ConfigurationService implements IConfigurationService {

    _serviceBrand: undefined;

    private readonly _onDidChangeConfiguration = new Emitter<IConfigurationChangeEvent>();
    readonly onDidChangeConfiguration = this._onDidChangeConfiguration.event;


    getValue<T>(section: string): T {
        return null as unknown as T;
    }
    
    updateValue(key: string, value: any): Promise<void> {
        return Promise.resolve();
    }

}